module.exports = __webpack_public_path__ + "img/Bhutan.46eeccc6.svg";